import React, {PureComponent, Fragment} from 'react';
import './index.scss';
import {Button, WhiteSpace, Badge, ListView, List, WingBlank} from 'antd-mobile';
import {Icon} from 'antd';
import history from './../../../utils/history';
import {getIndexList} from '../store/actionCreators';
import {connect} from 'react-redux';

import {IMAGE_URL, CHECK_loginToken} from './../../../utils/api';

class Main extends PureComponent {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            indexData: [],
        };
        let register = Storage.Base.getInstance().get('register');
        if (!register) {
            history.push('/bind');
            return;
        }

    }

    componentDidMount() {
        let storage = Storage.Base.getInstance();
        let oauthInfo = storage.get('_loginTk');
        if (oauthInfo === null) {
            history.push('./login');
            return;
        }
        let register = Storage.Base.getInstance().get('register');
        if (!register) {
            history.push('/bind');
            return;
        }

        this.props.getIndexList();
        setTimeout(() => {
            this.setState({
                isLoading: false,
            });
        }, 600);
    }

    onEndReached = (event) => {
        if (this.state.isLoading && !this.state.hasMore) {
            return;
        }
        this.setState({isLoading: true});
        setTimeout(() => {
            this.setState({
                isLoading: false,
            });
        }, 1000);
    }

    handleNavUrl(url, param) {
        if (url === '/space') {
            history.push(url + "/" + param.id, {id: param.id});
        } else {
            history.push(url, {customerDetail: "/my"});
        }
    }

    render() {
        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED'
                }}
            />
        );
        const {indexList = []} = this.props.indexList.home;
        let {dataSource} = this.state;
        let index = indexList.length - 1;
        const row = (rowData, sectionID, rowID) => {
            if (index < 0) {
                index = indexList.length - 1;
            }
            const obj = indexList[index--];
            return (
                <WingBlank>
                    <div key={rowID} style={{padding: '0 15px'}} data-id={obj.id}>
                        <div
                            style={{
                                lineHeight: '40px',
                                color: '#888',
                                fontSize: 18,
                                borderBottom: '1px solid #F6F6F6',
                            }}
                        >{obj.name}</div>
                        <div style={{display: '-webkit-box', display: 'flex', padding: '10px 0'}} onClick={(e) => {
                            e.stopPropagation();
                            this.handleNavUrl("/space", obj);
                        }}>
                            {
                                obj.img ?
                                    <img style={{height: '64px', marginRight: '15px'}} src={IMAGE_URL + obj.img}
                                         alt=""/>
                                    : <img style={{
                                        height: '64px',
                                        width: "120px",
                                        border: "none",
                                        background: "#eee",
                                        marginRight: '15px'
                                    }} alt=""/>
                            }
                            <div style={{lineHeight: 1, width: '100%'}}>
                                <div style={{marginBottom: '8px'}}>{obj.address}</div>
                                <List.Item className="home-list" style={{fontSize: "12px", borderBottom: "none"}}>
                                    <span className="phone-logo"/>
                                    <span style={{color: "#E87908", marginLeft: "8px"}}>{obj.telphone}</span>
                                </List.Item>
                            </div>
                        </div>
                    </div>
                </WingBlank>
            );
        };

        return (
            <Fragment>
                <div style={{position: "relative"}}>
                    <div className="index-logo"></div>
                    <div className="index-body">
                        <ListView
                            ref={el => this.lv = el}
                            dataSource={dataSource.cloneWithRows(indexList)}
                            renderHeader={() => <div>
                                <div className="index-icon"></div>
                                <span style={{color: "#FFFFFF"}}>请选择球馆</span></div>}
                            renderFooter={() => (<div style={{padding: 30, textAlign: 'center'}}>
                                {this.state.isLoading ? '加载中...' : ''}
                            </div>)}
                            renderRow={row}
                            renderSeparator={separator}
                            className="am-list"
                            pageSize={4}
                            useBodyScroll
                            onScroll={() => {
                                console.log('scroll');
                            }}
                            scrollRenderAheadDistance={500}
                            onEndReached={this.onEndReached}
                            onEndReachedThreshold={10}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (home) => {
    return {
        indexList: home
    }
};

const mapDispatchToProps = (dispatch) => ({
    getIndexList: data => dispatch(getIndexList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);